import dayjs from 'dayjs';
import { IStoredAuth } from '@/types/auth';
import { removeCartStorage } from '@/utils/cart';
import storage from '@/utils/storage';

export const setStoreAuthResult = (
  // eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
  storedAuthResult: IStoredAuth
) => {
  const expireDate = dayjs();
  storage.setItem('webAccessToken', storedAuthResult.webAccessToken);
  storage.setItem('refreshToken', storedAuthResult.refreshToken);
  storage.setItem('expiresIn', storedAuthResult.expiresIn);
  storage.setItem('expireDate', expireDate.add(storedAuthResult.expiresIn - 10, 's'));
  storage.setItem('scope', storedAuthResult.scope);
};

export const cleanLocalStorage = () => {
  storage.removeItem('webAccessToken');
  storage.removeItem('refreshToken');
  storage.removeItem('expiresIn');
  storage.removeItem('expireDate');
  storage.removeItem('scope');
  storage.removeItem('currentUser');
  storage.removeItem('cartRef');
  storage.removeItem('currentOcassion');
};

export const clearUserData = () => {
  storage.removeItem('webAccessToken');
  storage.removeItem('refreshToken');
  storage.removeItem('expiresIn');
  storage.removeItem('expireDate');
  storage.removeItem('scope');
  storage.removeItem('currentUser');
};

export const cleanSessionStorage = () => {
  sessionStorage.clear();
};

export const getStoredAuthResult = () => {
  const storedAuthResult: IStoredAuth = {
    webAccessToken: '',
    expireDate: '',
    expiresIn: 0,
    refreshToken: '',
    scope: '',
  };
  if (storage.getItem('webAccessToken')) {
    storedAuthResult.webAccessToken = storage.getItem('webAccessToken');
    storedAuthResult.refreshToken = storage.getItem('refreshToken');
    storedAuthResult.scope = storage.getItem('roles');
    storedAuthResult.scope = storage.getItem('scope');
    storedAuthResult.expireDate = storage.getItem('expireDate');
  }

  return storedAuthResult;
};

export const isTokenNotExpired = () => {
  const expireDate = dayjs(storage.getItem('expireDate'));
  const now = dayjs();
  return now.isBefore(expireDate);
};

export const logout = () => {
  const config = storage.getItem('config');
  const url = config?.otp_login ? '/auth/login-with-mobile-otp' : '/get-started';

  cleanLocalStorage();
  cleanSessionStorage();
  removeCartStorage();
  // redirect page to above url
  window.location.href = url;
};
